import template from "./bProgressBar.html";

export function bProgressBarDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bProgressBarController,
    controllerAs: 'bProgressBar',
    bindToController: true,
    scope: {
      bar: "=",
      max: "="
    },
    transclude: true
  };
  return directive;
}

class bProgressBarController {
  constructor ($scope, Work) {
    'ngInject';
    this.Work = Work;
    this.barPercentage = 0;
    $scope.$watch(() => this.bar, () => { this.barPercentage = Math.min(100,(100 * this.bar/this.max)); });
    $scope.$watch(() => this.max, () => { this.barPercentage = Math.min(100,(100 * this.bar/this.max)); });
  }
}